import Color from 'color';
import memoize from 'lodash.memoize';

import { FADE_OPACITY } from 'src/containers/ProjectDiagram/constants/styles';
import { ModelData } from 'src/containers/ProjectDiagram/types/model';

const whiteColor = Color('white');

type ColorParam = ConstructorParameters<typeof Color>[0];

export const lightenWithoutTransparency = memoize(
  (color: ColorParam, opacity: number) => {
    return Color(color)
      .mix(whiteColor, 1 - opacity)
      .toString();
  }
);

export const determineValueFromDraft =
  <T>(
    draftCb: (modelData: ModelData, obj: go.Shape | go.TextBlock) => boolean,
    defaultValue: T,
    draftValue?: T
  ) =>
  (modelData: ModelData, obj: go.Shape | go.TextBlock) => {
    return draftValue !== undefined &&
      modelData.draftData &&
      draftCb?.(modelData, obj)
      ? draftValue
      : defaultValue;
  };

export const determineColorFromSelection =
  (
    draftCb: (modelData: ModelData, obj: go.Shape | go.TextBlock) => boolean,
    defaultColor: ColorParam,
    draftColor?: ColorParam
  ) =>
  (modelData: ModelData, obj: go.Shape | go.TextBlock) => {
    const color = determineValueFromDraft(
      draftCb,
      defaultColor,
      draftColor
    )(modelData, obj) as string;
    return modelData.selection.length &&
      !obj.part?.isSelected &&
      color !== 'transparent'
      ? lightenWithoutTransparency(color, FADE_OPACITY)
      : color;
  };

export const determineOpacityFromSelection =
  () => (modelData: ModelData, obj: go.Shape | go.TextBlock) => {
    return modelData.selection.length && !obj.part?.isSelected
      ? FADE_OPACITY
      : 1.0;
  };
